module.exports = __webpack_public_path__ + "img/whats-new.9ea3cb88.png";